// Floating navigation items
export const NAV_ITEMS = [
  { id: 'insurance', label: 'Insurance & Savings' },
  { id: 'grants', label: 'Grants' },
  { id: 'laws', label: 'Laws' },
  { id: 'local', label: 'Local Programs' },
  { id: 'emergency', label: 'Emergency Prep' },
  { id: 'calfire', label: 'CAL FIRE' },
  { id: 'federal', label: 'Federal' },
];

// ═══ Insurance & Savings ═══
export const INSURANCE_DATA = [
  {
    title: 'FAIR Plan Wildfire Hardening Discounts',
    description: 'Save up to 16.4% — 12 discounts for defensible space, home hardening, and community actions.',
    url: 'https://www.cfpnet.com/wp-content/uploads/2025/11/Wildfire-Hardening-Discounts-for-Dwelling-Fire-Commercial-Policies-2025.11.15.pdf',
    icon: '🛡️',
    tag: 'Insurance Savings',
  },
  {
    title: 'California FAIR Plan',
    description: 'Insurer of last resort — basic fire coverage when standard carriers have dropped your policy.',
    url: 'https://www.cfpnet.com/',
    icon: '🏠',
    tag: 'Insurance',
  },
  {
    title: 'Find a FAIR Plan Broker',
    description: 'California Department of Insurance — search for licensed FAIR Plan brokers near you.',
    url: 'https://interactive.web.insurance.ca.gov/apex_extprd/f?p=400:50',
    icon: '🔍',
  },
  {
    title: 'Safer from Wildfires Framework',
    description: 'CA Dept. of Insurance — requires insurers to offer discounts for wildfire mitigation work.',
    url: 'https://www.insurance.ca.gov/01-consumers/200-wrr/Safer-from-Wildfires.cfm',
    icon: '💰',
    tag: 'Insurance Savings',
  },
  {
    title: 'Make It FAIR Act (AB 1680)',
    description: 'Proposed legislation to expand FAIR Plan coverage and improve claims handling.',
    url: 'https://www.insurance.ca.gov/0400-news/0100-press-releases/2026/release005-2026.cfm',
    icon: '📜',
  },
  {
    title: 'California Department of Insurance',
    description: 'Official consumer resources for wildfire insurance questions and complaints.',
    url: 'https://www.insurance.ca.gov',
    icon: '🏛️',
  },
];

// ═══ Grants & Financial Help ═══
export const GRANTS_DATA = [
  {
    title: 'CA Safe Homes Grant (AB 888)',
    description: 'Up to $10,000 for home hardening — vents, roofing, windows. Prioritized for low-income homeowners.',
    url: 'https://www.fire.ca.gov/home-hardening',
    icon: '💰',
    tag: 'State Grant',
  },
  {
    title: 'FEMA Hazard Mitigation Grant (HMGP)',
    description: 'Federal post-disaster grants for defensible space, home hardening, and fuel reduction.',
    url: 'https://www.fema.gov/grants/mitigation/hazard-mitigation',
    icon: '🏛️',
    tag: 'Federal Grant',
  },
  {
    title: 'CAL FIRE Prevention Grants',
    description: 'State funding for community fuel reduction, fire planning, and education projects.',
    url: 'https://www.fire.ca.gov/what-we-do/grants/wildfire-prevention-grants',
    icon: '🌲',
    tag: 'State Grant',
  },
  {
    title: 'Fire Safe Council Chipping Programs',
    description: 'Free or low-cost community chipping days — check with your county Fire Safe Council.',
    url: 'https://cafiresafecouncil.org/',
    icon: '🪵',
    tag: 'Free',
  },
  {
    title: 'NRCS EQIP Program',
    description: 'USDA grants for fuel reduction and prescribed burning on agricultural and forest lands.',
    url: 'https://www.nrcs.usda.gov/programs-initiatives/eqip-environmental-quality-incentives',
    icon: '🌾',
    tag: 'Federal Grant',
  },
];

// ═══ California Wildfire Laws ═══
export const LAWS_DATA = [
  {
    title: 'PRC 4291 — Defensible Space',
    description: 'Requires 100 ft of defensible space around structures in fire hazard areas.',
    url: 'https://www.fire.ca.gov/dspace',
    icon: '⚖️',
  },
  {
    title: 'AB 38 — Disclosure & Inspections',
    description: 'Sellers in fire hazard zones must get a defensible space inspection and disclose to buyers.',
    url: 'https://leginfo.legislature.ca.gov/faces/billNavClient.xhtml?bill_id=201920200AB38',
    icon: '📋',
  },
  {
    title: 'Chapter 7A — Building Standards',
    description: 'Fire-resistant construction requirements for new buildings in Very High fire zones.',
    url: 'https://osfm.fire.ca.gov/what-we-do/community-wildfire-preparedness-and-mitigation/building-in-the-wildland',
    icon: '🏗️',
  },
  {
    title: 'AB 888 — CA Safe Homes Program',
    description: 'Established grants up to $10K for wildfire home hardening retrofits.',
    url: 'https://leginfo.legislature.ca.gov/faces/billNavClient.xhtml?bill_id=202320240AB888',
    icon: '🏠',
  },
  {
    title: 'AB 1 — Insurance & Mitigation Incentives',
    description: 'Requires insurers to factor wildfire mitigation into coverage and pricing decisions.',
    url: 'https://leginfo.legislature.ca.gov/faces/billNavClient.xhtml?bill_id=202520260AB1',
    icon: '📜',
  },
];

// ═══ Nevada City & Nevada County Local Programs ═══
export const LOCAL_PROGRAMS_DATA = [
  {
    title: 'Free Defensible Space Inspections',
    description: 'Nevada City OES — schedule a free property walkthrough and get a personalized report.',
    url: 'https://nevadacityca.gov/187/Defensible-Space-Inspections',
    icon: '🔍',
    tag: 'Free',
  },
  {
    title: 'Defensible Space Assistance Program',
    description: 'Nevada City — free vegetation work for eligible residents (65+, disabled, low-income).',
    url: 'https://nevadacityca.gov/332/Defensible-Space-Assistance-Program',
    icon: '🤝',
    tag: 'Free',
  },
  {
    title: 'Community Green Waste + Chipping',
    description: 'Nevada City — free green waste drop-off and curbside chipping for residents.',
    url: 'https://nevadacityca.gov/287/Community-Green-Waste-Chipping-Program',
    icon: '🪵',
    tag: 'Free',
  },
  {
    title: 'Home Hardening Reimbursement',
    description: 'Nevada City — $100 reimbursement for fire-resistant upgrades (vents, weather stripping, caulking).',
    url: 'https://nevadacityca.gov/286/Creating-A-Fire-Resistant-Home',
    icon: '🏠',
    tag: 'Free',
  },
  {
    title: 'Wildfire Preparedness Hub',
    description: 'Nevada City — central page for all city wildfire programs, Measure C info, and contacts.',
    url: 'https://nevadacityca.gov/180/Wildfire-Preparedness',
    icon: '🏛️',
  },
  {
    title: 'Community Wildfire Protection Plan',
    description: 'Nevada City — the city\'s official wildfire risk reduction strategy and priorities.',
    url: 'https://nevadacityca.gov/271/Community-Wildfire-Protection-Plan-CWPP',
    icon: '📋',
  },
  {
    title: 'Fire Hazard Severity Zones (2025)',
    description: 'Nevada City — updated CAL FIRE zone maps. Check your parcel designation.',
    url: 'https://nevadacityca.gov/316/Fire-Hazard-Severity-Zones---2025',
    icon: '🗺️',
  },
  {
    title: 'Firewise Communities',
    description: 'Nevada City — learn how your neighborhood can earn Firewise USA designation.',
    url: 'https://nevadacityca.gov/300/Fire-Wise-Communities',
    icon: '🏘️',
  },
  {
    title: 'Fuels Reduction & Open Space Projects',
    description: 'Nevada City — current city-led fuel reduction projects and open space management.',
    url: 'https://nevadacityca.gov/179/Nevada-City-Fuels-Reduction-Open-Space-P',
    icon: '🌲',
  },
];

// ═══ Emergency Preparedness (Nevada County) ═══
export const EMERGENCY_PREP_DATA = [
  {
    title: 'CodeRED Emergency Alerts',
    description: 'Nevada County — sign up for wildfire evacuation calls, texts, and emails.',
    url: 'https://www.onsolve.com/landing/sign-up-for-codered-emergency-alerts/',
    icon: '🚨',
    tag: 'Sign Up Now',
  },
  {
    title: 'Ready Nevada County',
    description: 'Nevada County OES — preparedness hub, go-bag checklists, and household toolkit.',
    url: 'https://www.nevadacountyca.gov/4140/Ready-Nevada-County',
    icon: '📦',
  },
  {
    title: 'Evacuation Route Pre-Planner',
    description: 'Nevada County — interactive map to plan your primary and alternate escape routes.',
    url: 'https://nevcounty.maps.arcgis.com/apps/MapSeries/index.html?appid=dfae8e3b36e3455bbf9dcc865349e72e',
    icon: '🗺️',
  },
  {
    title: 'Ready Nevada County Dashboard',
    description: 'Nevada County — live incidents, alerts, and emergency status in one place.',
    url: 'https://www.nevadacountyca.gov/dashboard',
    icon: '📊',
  },
  {
    title: 'Know Your Zone',
    description: 'Nevada County — find your evacuation zone and understand what it means.',
    url: 'https://www.nevadacountyca.gov/3223',
    icon: '📍',
  },
  {
    title: 'Burn Days & Permits',
    description: 'Nevada County — check today\'s burn status and get burn permit information.',
    url: 'https://www.nevadacountyca.gov/2753',
    icon: '🔥',
  },
  {
    title: 'Prepare for Wildfire (Ready, Set, Go!)',
    description: 'Nevada County OES — step-by-step Ready, Set, Go! guidance: fire-resistant home, go-bags, and evacuation planning.',
    url: 'https://www.nevadacountyca.gov/2710/Prepare',
    icon: '🧰',
  },
  {
    title: 'Roadmap to Resilience',
    description: 'Nevada County — multi-step walkthrough for community and personal preparedness.',
    url: 'https://www.nevadacountyca.gov/2711/Roadmap-to-Resilience',
    icon: '🗺️',
  },
  {
    title: 'Genasys Protect — Find Your Zone',
    description: 'Live evacuation-zone lookup and real-time alerts. Search your address to see your zone and current status.',
    url: 'https://protect.genasys.com/',
    icon: '📍',
    tag: 'Sign Up Now',
  },
  {
    title: 'Education & Outreach',
    description: 'Nevada County OES — wildfire preparedness classes, presentations, and community education.',
    url: 'https://www.nevadacountyca.gov/4122/Education-and-Outreach',
    icon: '🎓',
  },
  {
    title: 'Emergency Preparedness Hub',
    description: 'Nevada County OES — the central hub for alerts, evacuation, and household readiness resources.',
    url: 'https://www.nevadacountyca.gov/3471/Emergency-Preparedness',
    icon: '🛟',
  },
];

// ═══ CAL FIRE Programs ═══
export const CALFIRE_DATA = [
  {
    title: 'Defensible Space (PRC 4291)',
    description: 'CAL FIRE — inspections and guidance for maintaining 100 ft of defensible space.',
    url: 'https://www.fire.ca.gov/dspace',
    icon: '🛡️',
  },
  {
    title: 'Ready for Wildfire',
    description: 'CAL FIRE — evacuation planning, go-bag checklists, home hardening guides, and alerts.',
    url: 'https://www.readyforwildfire.org/',
    icon: '🔥',
  },
  {
    title: 'Hardening Your Home',
    description: 'CAL FIRE — step-by-step guide to making your home more resistant to wildfire.',
    url: 'https://www.readyforwildfire.org/prepare-for-wildfire/hardening-your-home/',
    icon: '🏠',
  },
  {
    title: 'Fire Hazard Severity Zone Maps',
    description: 'OSFM — look up your property\'s fire hazard zone (Very High, High, or Moderate).',
    url: 'https://osfm.fire.ca.gov/what-we-do/community-wildfire-preparedness-and-mitigation/fire-hazard-severity-zones',
    icon: '🗺️',
  },
  {
    title: 'Office of the State Fire Marshal',
    description: 'OSFM — state programs for community-level wildfire mitigation, building standards, and fire safety.',
    url: 'https://osfm.fire.ca.gov/',
    icon: '🏛️',
  },
];

// ═══ Federal Programs ═══
export const FEDERAL_DATA = [
  {
    title: 'FEMA Hazard Mitigation Grant (HMGP)',
    description: 'FEMA — post-disaster grants for defensible space, home hardening, and fuel reduction.',
    url: 'https://www.fema.gov/grants/mitigation/hazard-mitigation',
    icon: '🏛️',
  },
  {
    title: 'FEMA Post-Fire Recovery',
    description: 'FEMA — individual and public assistance for communities recovering from wildfire.',
    url: 'https://www.fema.gov/disaster/recover',
    icon: '🔄',
  },
  {
    title: 'Fire Management Assistance Grants',
    description: 'FEMA — federal funding for wildfire mitigation and control on public or private lands.',
    url: 'https://www.fema.gov/assistance/public/fire-management-assistance',
    icon: '🚒',
  },
  {
    title: 'US Forest Service Fire Programs',
    description: 'USFS — community fuel reduction, forest health, and WUI wildfire prevention.',
    url: 'https://www.fs.usda.gov/managing-land/fire',
    icon: '🏔️',
  },
  {
    title: 'IBHS Wildfire Prepared Home',
    description: 'IBHS — research-based designation and checklist for wildfire-resistant homes.',
    url: 'https://wildfireprepared.org/',
    icon: '🏠',
  },
  {
    title: 'Firewise USA',
    description: 'NFPA — national program recognizing communities that take action to reduce wildfire risk.',
    url: 'https://www.nfpa.org/education-and-research/wildfire/firewise-usa',
    icon: '🤝',
  },
];

// ═══ Community Organizations ═══
export const COMMUNITY_DATA = [
  {
    title: 'California Fire Safe Council',
    description: 'Statewide nonprofit — education, grants, and local Fire Safe Council coordination.',
    url: 'https://cafiresafecouncil.org/',
    icon: '🌟',
  },
  {
    title: 'El Dorado County Fire Safe Council',
    description: 'Sierra foothills — defensible space inspections, chipping, and fuel reduction.',
    url: 'https://edcfiresafe.org/',
    icon: '⛰️',
  },
  {
    title: 'Placer Sierra Fire Safe Council',
    description: 'Placer County — wildfire preparedness, fuel reduction, and community education.',
    url: 'https://www.placer.ca.gov/5724/Placer-Sierra-Fire-Safe-Council',
    icon: '🌲',
  },
];

// ═══ Seasonal Fire Safety Calendar ═══
export const CALENDAR_DATA = [
  {
    season: 'Spring',
    months: 'March — May',
    color: 'green',
    icon: '🌱',
    title: 'Prepare & Clear',
    tasks: [
      'Clear dead vegetation and debris from winter storms',
      'Create or refresh defensible space around your home',
      'Schedule tree trimming before fire season',
      'Clean gutters and remove leaf litter from roof',
    ],
  },
  {
    season: 'Summer',
    months: 'June — August',
    color: 'red',
    icon: '☀️',
    title: 'Stay Vigilant',
    tasks: [
      'Keep vegetation watered within 30 feet of structures',
      'Mow grass to 4 inches or less',
      'Store firewood 30+ feet from structures',
      'Maintain your evacuation go-bag and plan',
    ],
  },
  {
    season: 'Fall',
    months: 'September — November',
    color: 'orange',
    icon: '🍂',
    title: 'Peak Season Cleanup',
    tasks: [
      'Clear fallen leaves and dead material promptly',
      'Check for ember entry points — vents, eaves, gaps',
      'Review insurance coverage before renewal season',
      'Participate in community chipping days',
    ],
  },
  {
    season: 'Winter',
    months: 'December — February',
    color: 'blue',
    icon: '❄️',
    title: 'Plan & Invest',
    tasks: [
      'Research home hardening upgrades for spring',
      'Apply for grants and financial assistance',
      'Get quotes for defensible space work',
      'Review and update your family evacuation plan',
    ],
  },
];

// ═══ Section config — single source of truth for rendering + search/filter ═══
// `id` doubles as the filter-chip key and the anchor id for grouped sections.
export const SECTIONS = [
  {
    id: 'insurance',
    eyebrow: 'Insurance',
    chip: 'Insurance',
    title: 'Insurance & Savings',
    subtitle: 'FAIR Plan discounts, Safer from Wildfires framework, and coverage resources.',
    data: INSURANCE_DATA,
  },
  {
    id: 'grants',
    eyebrow: 'Money & Funding',
    chip: 'Grants',
    title: 'Grants & Financial Help',
    subtitle: 'State and federal programs that can help fund your wildfire mitigation work.',
    data: GRANTS_DATA,
  },
  {
    id: 'laws',
    eyebrow: 'Legal',
    chip: 'Laws',
    title: 'California Wildfire Laws',
    subtitle: 'Key legislation affecting homeowners in fire hazard zones.',
    data: LAWS_DATA,
  },
  {
    id: 'local',
    eyebrow: 'Nevada County',
    chip: 'Local',
    title: 'Local Programs',
    subtitle: 'Free inspections, chipping, and assistance from Nevada City and Nevada County.',
    data: LOCAL_PROGRAMS_DATA,
  },
  {
    id: 'emergency',
    eyebrow: 'Be Ready',
    chip: 'Emergency',
    title: 'Emergency Preparedness',
    subtitle: 'Alerts, evacuation planning, and Ready Nevada County resources from the county OES.',
    data: EMERGENCY_PREP_DATA,
  },
  {
    id: 'calfire',
    eyebrow: 'State',
    chip: 'CAL FIRE',
    title: 'CAL FIRE Programs',
    subtitle: 'Official California Department of Forestry and Fire Protection resources.',
    data: CALFIRE_DATA,
  },
  {
    id: 'federal',
    eyebrow: 'Federal',
    chip: 'Federal',
    title: 'Federal Programs',
    subtitle: 'National programs for wildfire mitigation, recovery, and community preparedness.',
    data: FEDERAL_DATA,
  },
  {
    id: 'community',
    eyebrow: 'Community',
    chip: 'Fire Safe Councils',
    title: 'Fire Safe Councils',
    subtitle: 'Regional nonprofits offering inspections, chipping, grants, and education.',
    data: COMMUNITY_DATA,
  },
];

// Flattened list of every resource item, tagged with its section — used for
// search and filtering.
export const ALL_RESOURCES = SECTIONS.flatMap(section =>
  section.data.map(item => ({
    ...item,
    sectionId: section.id,
    sectionChip: section.chip,
  }))
);
